module.exports = __webpack_public_path__ + "img/food_businessmen_logo@2x.8068989b.png";